const SMSTemplate = {
  smsTemplate: 'SMS Template',
  addSMSTemplate: 'Add SMS Template',
  editSMSTemplate: 'Edit SMS Template',
};
export default SMSTemplate;
